// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ContainerVisibilityToggleController from "./container_visibility_toggle_controller"
application.register("container-visibility-toggle", ContainerVisibilityToggleController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PolicyReports__SelectOwnersController from "./policy_reports/select_owners_controller"
application.register("policy-reports--select-owners", PolicyReports__SelectOwnersController)

import RolesController from "./roles_controller"
application.register("roles", RolesController)
